export enum StyleItemLabel {
    POPULAR = 'popular',
    TAFFI_CHOICE = 'taffi_choice',
    BEST_SELLER = 'best_seller',
    LIMITED_TIME = 'limited_time',
    EXCLUSIVE = 'exclusive',
    FEATURED = 'featured',
}
